import React, { createContext, useContext } from 'react'
import { type IButtonActionsType } from '@/types/FormLayout'

interface IButtonActionsContextType {
  buttonActions: IButtonActionsType
  setButtonActions: React.Dispatch<React.SetStateAction<IButtonActionsType>>
}

const ButtonActionsContext = createContext<IButtonActionsContextType | null>(
  null
)

export function useButtonActionsContext() {
  const context = useContext(ButtonActionsContext)
  if (!context) {
    throw new Error(
      'useButtonActionsContext must be used within a ButtonActions'
    )
  }
  return context
}

export default ButtonActionsContext
